import styled from "styled-components"

import {Para} from "@irati/ui/src/Labels"
import Button from "@irati/ui/src/Button"

export const Flex = styled.div`
  display: flex;
  align-items: center;
`

export const InstructionsButton = styled.div`
  margin: 20px 0 0;
`

export const InfoSections = styled.div`
  margin: 30px 0;
`

export const EmailUsAtPara = styled(Para)`
  margin-left: 5px;
  margin-top: 3px;
`

export const Accordions = styled.div`
  margin: 30px 0;
`

export const MembershipCertificateButton = styled(Button)`
  margin-bottom: 20px;
`

export const MarginLeft = styled.div`
  display: inline;
  margin-left: 5px;
`
